import { initLenis } from './lib/lenis';
import { initNav } from './modules/nav';
import { initReveals } from './modules/reveals';
import { initAnchors } from './modules/anchors';
import { initVideoModal } from './modules/videoModal';
import { initIntercom } from './modules/intercom';
import { initAccordion } from './modules/accordion';
import { initScrollProgress } from './modules/scrollProgress';
import { initCounters } from './modules/counters';
import { initDevice } from './modules/device';
import { initFeaturesSticky } from './modules/featuresSticky';
import { initPointerFx } from './modules/pointerFx';
import { initHeroParallax } from './modules/heroParallax';
import { initToc } from './modules/toc';
import { initShare } from './modules/share';
import { initSort } from './modules/sort';

// Flip the CSS gate (also done inline in header.php before first paint):
// reveal/hide states only apply under `html.js`.
document.documentElement.classList.add('js');

function safe(label: string, fn: () => void): void {
  try { fn(); } catch (err) { console.error(`[boot] ${label} failed`, err); }
}

function boot(): void {
  // Each module is wrapped so one broken module can't take down the boot
  // sequence. Lenis first — other modules scroll and listen through it.
  safe('lenis',           initLenis);
  safe('nav',             initNav);
  safe('reveals',         initReveals);
  safe('video-modal',     initVideoModal);
  safe('intercom',        initIntercom);
  safe('anchors',         initAnchors);
  safe('accordion',       initAccordion);
  safe('scroll-progress', initScrollProgress);
  safe('counters',        initCounters);
  safe('device',          initDevice);
  safe('features-sticky', initFeaturesSticky);
  safe('hero-parallax',   initHeroParallax);
  safe('pointer-fx',      initPointerFx);
  safe('toc',             initToc);
  safe('share',           initShare);
  safe('sort',            initSort);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
